import request from '@/router/axios'
import env from '@/config/env'

// 获取分页
export function pageApi(params) {
  return request({
    url: env.officeUrl + '/asset-admin/v1/page',
    method: 'post',
    data: params
  })
}
// 获取部门
export function treeSimple(params) {
  return request({
    url: env.officeUrl + '/department/tree/simple',
    method: 'get',
    params
  })
}
// 根据部门获取使用人
export function userPerson(params) {
  return request({
    url: env.officeUrl + '/employee/page',
    method: 'post',
    data: params
  })
}
// 资产新增
export function assetSave(params) {
  return request({
    url: env.officeUrl + '/asset-admin/v1/save',
    method: 'post',
    data: params
  })
}
// 资产详情
export function assetDetail(params) {
  return request({
    url: env.officeUrl + '/asset-admin/v1/detail/' + params,
    method: 'get'
  })
}
// 获取日志列表
export function logList(params) {
  return request({
    url: env.officeUrl + '/log/list',
    method: 'get',
    params
  })
}
// 搜索员工
export function employeeSearch(params) {
  return request({
    url: env.officeUrl + '/employee/search',
    method: 'get',
    params
  })
}
// 批量发起调拨-归还
export function batchTransfer(params) {
  return request({
    url: env.officeUrl + '/asset-admin/v1/batch-transfer',
    method: 'post',
    data: params
  })
}
// 获取状态
export function assetStatus(params) {
  return request({
    url: env.officeUrl + '/asset-admin/v1/asset-status',
    method: 'get',
    params
  })
}
// 资产编辑
export function assetEdit(params) {
  return request({
    url: env.officeUrl + '/asset-admin/v1/edit-batch',
    method: 'post',
    data: params
  })
}
// 资产批量报废-退库操作
export function assetScrap(params) {
  return request({
    url: env.officeUrl + '/asset-admin/v1/batch-operate',
    method: 'post',
    data: params
  })
}
// 打印标签
export function assetPrint(params) {
  return request({
    url: env.officeUrl + '/asset-admin/v1/print',
    method: 'post',
    data: params
  })
}
// 资产批量导入保存
export function importSave(params) {
  return request({
    url: env.officeUrl + '/asset-admin/v1/import-save',
    method: 'post',
    data: params
  })
}
// 资产归还分页列表
export function receivePage(params) {
  return request({
    url: env.officeUrl + '/asset-admin/v1/receive-page',
    method: 'get',
    params
  })
}
// 调拨-归还批量操作
export function batchOperate(params) {
  return request({
    url: env.officeUrl + '/asset-admin/v1/transfer/batch-operate',
    method: 'post',
    data: params
  })
}
// 归还中资产数量
export function receiveCount(params) {
  return request({
    url: env.officeUrl + '/asset-admin/v1/receive-count',
    method: 'get',
    params
  })
}
// 获取分页对象映射字段
export function importPageField(params) {
  return request({
    url: env.ferryUrl + '/import-page/field',
    method: 'get',
    params
  })
}
